import {
	getRelatedProductBySkuFromAdapter,
} from 'application/adapters/ecommerce/relatedProductsAdapter';

export const getRelatedProductBySku: (
	productSku: string,
	accessToken: any,
	locale?: string,
	bpId?: string,
	country?: string,
) => Promise<any> = async (
	productSku,
	accessToken,
	locale,
	bpId,
	country,
) => {
	const product = getRelatedProductBySkuFromAdapter(
		productSku,
		accessToken,
		locale,
		bpId,
		country,
	);

	return product;
};